import { Role, useAuthContext } from "@/components/AuthorizationProvider.tsx";
import { useCallback } from "react";
import { usePrivy } from "@privy-io/react-auth";

// Role hierarchy from most to least privileged
const ROLE_HIERARCHY = [Role.SuperAdmin, Role.TenantAdmin, Role.Creator];

export function useAuth() {
  const { authenticated, ready } = usePrivy();
  const { userAuthorization } = useAuthContext();

  const isAuthenticated = ready && authenticated && userAuthorization;
  const userRole = userAuthorization?.role;

  /** Returns true if the user has {@link role} or one with more permissions. */
  const hasAtLeastRole = useCallback(
    (role: Role) => {
      if (!isAuthenticated) return false;

      const roleIndex = ROLE_HIERARCHY.indexOf(role);

      if (roleIndex === -1) {
        return false;
      }

      return ROLE_HIERARCHY.indexOf(userRole) <= roleIndex;
    },
    [isAuthenticated, userRole],
  );

  if (isAuthenticated) {
    return {
      authenticated: true,
      hasAtLeastRole,
      username: userAuthorization.qs_username,
    } as const;
  }

  return {
    authenticated: false,
    hasAtLeastRole,
  } as const;
}
